import React from 'react';
import moment from 'moment';
import { connect, ConnectedProps } from 'react-redux';
import { IStore } from '../../../../../../../redux/store';
import { TAnnex6V2Record } from '../../../../../../../redux/app/annex6-v2/@types';
import { TAnnex6V2GroupC1 } from '../../../../../../../redux/app/annex6-v2/groups/group-c';
import Annex6V2TableRows from '../../_elements_v2/Annex6V2TableRows';
import CommaSeparator from '../../../../../../_common/CommaSeparator';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
    annex6V2Record: TAnnex6V2Record;
    isStrikedOff?: boolean;
    theme?: 'light' | 'dark';
};
type Annex6V2GroupC1PreviewProps = OwnProps & PropsFromRedux;

function Annex6V2GroupC1Preview(props: Annex6V2GroupC1PreviewProps) {
    const record = props.annex6V2Record as TAnnex6V2GroupC1;
    const operationDate = moment(record.selectedDate, 'YYYY-MM-DD').format(
        'DD-MMM-YYYY'
    );
    const { itemC1P1, itemC1P2, itemC0, itemC5P1, itemC5P2 } = record;

    function renderMain() {
        const tableRows = [
            [operationDate, 'C', '1', renderItemC1P1()],
            [null, null, '2', renderItemC1P2()],
        ];

        if (record.remarks) {
            tableRows.push([null, null, 'NOTE', record.remarks]);
        }
        if (props.scrubberInfo) {
            tableRows.push([null, null, '-', getScrubberInfo()]);
        }

        return (
            <Annex6V2TableRows
                record={record}
                tableRows={tableRows}
                theme={props.theme}
            />
        );
    }

    function renderItemC1P1() {
        const { date: smtDate, time: smtTime } = itemC1P1;
        const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
        const utcTime = moment.utc(dateTimeLocal);

        return (
            <h4 className="font-medium uppercase">
                Commencement of{' '}
                <CommaSeparator
                    items={record.itemC5P1.equipmentsUsed.map((equipment) =>
                        equipment.split('_').join(' ')
                    )}
                    lastItemSeperator={' & '}
                />{' '}
                Fuel Change Over upon {itemC0.entryOrExit} ECA on{' '}
                {utcTime.format('HH:mm')} hrs UTC,{' '}
                {utcTime.format('DD-MMM-YYYY')} ({smtTime} SMT on{' '}
                {moment(smtDate, 'YYYY-MM-DD').format('DD-MMM-YYYY')}) at{' '}
                {itemC1P1.latitude} | {itemC1P1.longitude}
            </h4>
        );
    }

    function renderItemC1P2() {
        return (
            <h4 className="font-medium uppercase">
                <div>
                    Fuel Oil ROB and Sulphur Content at ECA {itemC0.entryOrExit}
                    :
                    <br />
                    Changeover fuel from {itemC5P1.changingFrom.fuelType} (
                    {itemC5P1.changingFrom.sulphurContent}%) to {''}
                    {itemC5P1.changingTo.fuelType} (
                    {itemC5P1.changingTo.sulphurContent}%)
                    <br />
                    <CommaSeparator
                        items={itemC1P2.tanks.map(
                            (tank) =>
                                `${tank.selectedTank.tankName} - ${tank.fuelOilRob}m³`
                        )}
                        customSeperator={<br />}
                    />
                </div>
            </h4>
        );
    }

    function getScrubberInfo() {
        const { date: smtDate, time: smtTime } = itemC5P2;
        const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
        const utcTime = moment.utc(dateTimeLocal);

        return (
            <h4 className="font-medium uppercase">
                Scrubber {itemC5P2.mode === 'start' ? 'Started' : 'Stopped'} on{' '}
                {utcTime.format('HH:mm')} hrs UTC,{' '}
                {utcTime.format('DD-MMM-YYYY')} ({smtTime} SMT on{' '}
                {moment(smtDate, 'YYYY-MM-DD').format('DD-MMM-YYYY')}) at{' '}
                {itemC5P2.latitude} | {itemC5P2.longitude}
            </h4>
        );
    }

    return renderMain();
}

function mapStateToProps(store: IStore) {
	const vesselStore = vesselSelectors._getStore(store);
    const scrubberInfo = vesselSelectors.getAnnexVIScrubberInfo(vesselStore);

    return {
        scrubberInfo,
    };
}

const reduxConnector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(Annex6V2GroupC1Preview);
